<template>
   <div class="advMain" id="page6">
     <div style="width: 1440px;margin: 0 auto;display: flex;justify-content: space-between;align-items: center;padding: 0 20px;box-sizing: border-box;">
       <div class="leftBlock">
         <h3 class="title">{{mk5.title}}</h3>
         <p class="message">
           {{mk5.content}}
         </p>
         <div
           style="width: 150px;height: 50px;border-radius: 40px;background: #fff;text-align: center;line-height: 50px;margin-top: 40px;background: linear-gradient(to bottom right, #02B4E0 40%, #14E1A0 99%);color: #fff;letter-spacing: 2px;cursor: pointer;" @click="childMethod">
           {{mk5.buttonName}}</div>
         <!-- <div class="buttonWrap"><Mybutton @clickFn="showForm">了解裂变复购</Mybutton></div> -->
       </div>
       <div class="rightBlock">
         <transition name="lb-img">
          <img class="lb_img" src="../../assets/images/lb_1.png" />
         </transition>
         <transition name="lb-img">
          <img class="lb_img" src="../../assets/images/lb_2.png" />
         </transition>
         <transition name="lb-img">
          <img class="lb_img" src="../../assets/images/lb_3.png" />
         </transition>
         <transition name="lb-img">
          <img class="lb_img" src="../../assets/images/lb_4.png" />
         </transition>
         <transition name="lb-img">
          <img class="lb_img" src="../../assets/images/lb_5.png" />
         </transition>
         <transition name="lb-img">
          <img class="lb_img" src="../../assets/images/lb_6.png" />
         </transition>
         <transition name="lb-img">
          <img class="lb_img" src="../../assets/images/lb_7.png" />
         </transition>
       </div>
     </div>
   </div>
</template>
<script>
  import {
      getIndex
    } from '@/api/api'
// import Mybutton from './Mybutton'
export default {
  name: 'codeBuy',
  components: {
    // Mybutton
  },
  props: {
    // buyShow: Boolean
  },
  data () {
    return {
      mk5: {}
    }
  },
  methods: {
    setIndex() {
      getIndex().then(res=> {
          this.mk5 = res.mk5
      })
    },
    childMethod () {
    			this.$emit('fatherMethod');
    		}
    // showForm () {
    //   this.$emit('changeVisible', true)
    // }
  },
  mounted() {
    this.setIndex()
  }
}
</script>
<style scoped lang="scss">

.lb-img-enter-active {
  animation: lb-in-out .8s;
  animation-delay: .1s;
}
.lb-img-leave-active {
  animation: lb-in-out .3s reverse;
  animation-delay: 0;
}

@keyframes lb-in-out {
  0% {
    opacity: 0.3;
    transform: scale(0.1) rotate(360deg);
  }
  60% {
    opacity: 0.5;
    transform: scale(1.2) rotate(180deg);
  }
  100%{
    opacity: 1;
    transform: scale(1) rotate(0);
  }
}

  .advMain{
    // padding: 12% 100px 45px;
    height: 560px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    .leftBlock{
      width: 525px;
      .title{
        font-size: 40px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: normal;
        color: #1F2329;
        line-height: 56px;
      }
      .message{
        width: 525px;
        font-size: 18px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: normal;
        color: #36444D;
        line-height: 28px;
      }
      .buttonWrap{
        margin-top: 50px;
      }
    }
    .rightBlock{
      width: 459px;
      height: 459px;
      background: url('../../assets/images/bg_5.png') top left no-repeat;
      position: relative;
      img:nth-child(1) {
        position: absolute;
        top: 78px;
        left: 106px;
      }
      img:nth-child(2) {
        position: absolute;
        top: 67px;
        left: 310px;
      }
      img:nth-child(3) {
        position: absolute;
        top: 221px;
        left: 398px;
      }
      img:nth-child(4) {
        position: absolute;
        top: 321px;
        left: 335px;
      }
      img:nth-child(5) {
        position: absolute;
        left: 214px;
        bottom: 59px;
      }
      img:nth-child(6) {
        position: absolute;
        left: 95px;
        bottom: 95px;
      }
      img:nth-child(7) {
        position: absolute;
        left: 10px;
        top: 213px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/components/CodeBuy.vue